import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import * as jwt_decode from "jwt-decode";
import { LanguagesService } from "@easyfo/common-lib";
import { ReportService } from '../../services/report';


@Component({
  selector: 'app-preview',
  templateUrl: './preview-report.component.html',
  styleUrls: ['./preview-report.component.css']
})
export class PreviewReportComponent {
  public hide: boolean = true;
  public report_name: string = "";
  public formGroup = new FormGroup({
    password: new FormControl(null)
  });

  private jwtToken: any;

  constructor(private titleService: Title,
    private route: ActivatedRoute,
    private reportService: ReportService,
    private languagesService: LanguagesService,
  ) {
    this.languagesService.setByCookies();
    this.route.queryParams.subscribe(params => {
      this.jwtToken = params['a'];
      let jwtData: any = this.getPayloadJWT(this.jwtToken);
      this.report_name = jwtData.n;
      this.titleService.setTitle(this.report_name);
    });
  }

  onApply() {
    const password = this.formGroup.get('password')?.value;
    if (!password) return;
    this.reportService.getPreview(this.jwtToken, password)
      .catch((err: any) => {

      });
  }

  private getPayloadJWT(token: string): any {
    try {
      return jwt_decode.jwtDecode(token);
    } catch (Error) {
      return null;
    }
  }
}
